import React from 'react';
import { IncorrectGuess } from '../../types/game';
import styles from './IncorrectAnswersGrid.module.css';
import artistAliases from '../../assets/artistAliases.json';

interface IncorrectAnswersGridProps {
    incorrectGuesses: IncorrectGuess[];
}

const IncorrectAnswersGrid: React.FC<IncorrectAnswersGridProps> = ({ incorrectGuesses }) => {
    if (!incorrectGuesses || incorrectGuesses.length === 0) {
        return null;
    }

    const aliasMap = new Map(artistAliases.map(item => [item.alias.toLowerCase(), item.trueName]));

    const renderUserGuess = (userGuess: string) => {
        const userGuessLower = userGuess.toLowerCase();
        const trueName = aliasMap.get(userGuessLower);

        if (trueName) {
            return (
                <span>
                    {userGuess} &rarr; {trueName}
                </span>
            );
        }

        return <span>{userGuess}</span>;
    };

    return (
        <div className={styles.incorrectAnswersContainer}>
            <h2>Review Your Answers</h2>
            <div className={styles.incorrectGrid}>
                {incorrectGuesses.map((item, index) => (
                    <div key={index} className={styles.incorrectItem}>
                        <a href={`https://gelbooru.com/index.php?page=post&s=view&id=${item.post.id}`} target="_blank" rel="noopener noreferrer">
                            <img src={item.post.imageUrl} alt="Incorrectly guessed art" className={styles.incorrectImage} />
                        </a>
                        <div className={styles.incorrectDetails}>
                            <p>Your guess: {renderUserGuess(item.userGuess)}</p>
                            <p>
                                Correct answer:{' '}
                                <a
                                    href={`https://gelbooru.com/index.php?page=post&s=list&tags=${encodeURIComponent(item.correctAnswer)}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.link}
                                >
                                    {item.correctAnswer}
                                </a>
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default IncorrectAnswersGrid; 